export default __webpack_public_path__ + "static/media/Kaspy-Phone2.9cdddb13.webp";